import React, { useState, useEffect, useRef } from 'react'

import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Image from 'react-bootstrap/Image'

import visaSVG from './images/visa.svg'
import mastercardSVG from './images/mastercard.svg'
import amexSVG from './images/amex.svg'
import discoverSVG from './images/discover.svg'

import Title from './Title'

const validateCardNumber = number => {
  //Check if the number contains only numeric value
  //and is of between 13 to 19 digits
  const regex = new RegExp('^[0-9]{13,19}$')
  if (!regex.test(number)) {
    return false
  }

  return luhnCheck(number)
}

const luhnCheck = val => {
  let checksum = 0 // running checksum total
  let j = 1 // takes value of 1 or 2

  // Process each digit one by one starting from the last
  for (let i = val.length - 1; i >= 0; i--) {
    let calc = 0
    // Extract the next digit and multiply by 1 or 2 on alternative digits.
    calc = Number(val.charAt(i)) * j

    // If the result is in two digits add 1 to the checksum total
    if (calc > 9) {
      checksum = checksum + 1
      calc = calc - 10
    }

    // Add the units element to the checksum total
    checksum = checksum + calc

    // Switch the value of j
    if (j === 1) {
      j = 2
    } else {
      j = 1
    }
  }

  //Check if it is divisible by 10 or not.
  return checksum % 10 === 0
}

const CreditCard = props => {
  const [ccType, setCcType] = useState(0)

  const creditCardRef = useRef({ cc: '', exp: '', cvc: '' })

  const ccRef = useRef('')
  const expRef = useRef('')
  const cvcRef = useRef('')

  const [required, setRequired] = useState()
  const [focused, setFocused] = useState({
    creditCard: false,
    expDate: false,
    cvc: false
  })
  const [changed, setChanged] = useState({
    creditCard: false,
    expDate: false,
    cvc: false
  })
  const [incomplete, setIncomplete] = useState({
    creditCard: false,
    expDate: false,
    cvc: false
  })
  const [valid, setValid] = useState({
    creditCard: false,
    expDate: false,
    cvc: false
  })
  //const incompleteMsgRef = useRef('')

  const [incompleteMsg, setIncompleteMsg] = useState({ type: '', msg: '' });

  useEffect(() => {
    // console.log('useEffect CreditCard', props.required)
    setRequired(props.required)
    setChanged({ creditCard: false, expDate: false, cvc: false })
    // setChanged(false)
  }, [props.required])

  useEffect(() => {
    //console.log('CreditCard valid', valid)
  }, [valid])

  const validateFields = () => {
    var msg = ''
    var type = ''
    var valid = { cc: false, exp: false, cvc: false }

    //console.log('validateFields')

    if (ccRef.current.value !== '') {
      if (
        (ccType === '3' && ccRef.current.value.length !== 17) ||
        ccRef.current.value.length !== 19
      ) {
        //console.log('credit card invalid')
        setIncomplete({ ...incomplete, creditCard: true })
        // setValid({ ...valid, creditCard: false })
        msg = 'Your card number is incomplete.'
        type = 'creditCard'

      } else {
        //console.log('credit card valid')
        valid.cc = true
        // setValid({ ...valid, expDate: true })
      }
    }

    if (expRef.current.value !== '') {
      //console.log('check exp date')
      if (expRef.current.value.length !== 7) {
        setIncomplete({ ...incomplete, expDate: true })
        //console.log('invalid exp date')
        // setValid({ ...valid, expDate: false })
        if (msg === '') {
            msg = "Your card's expiration date is incomplete."
            type = 'expDate'
          }
      } else {
        //console.log('valid exp date')
        valid.exp = true
        // setValid({ ...valid, expDate: true })
      }
    }
    if (cvcRef.current.value !== '') {
      if (
        (ccType === '3' && cvcRef.current.value.length !== 4) ||
        cvcRef.current.value.length !== 3
      ) {
        setIncomplete({ ...incomplete, cvc: true })
        // setValid({ ...valid, cvc: false })
        if (msg === '') {
            msg = "Your card's security code is incomplete."
            type = 'cvc'
          }
        // setIncomplete({ creditCard: false, expDate: false, cvc: true })
      } else {
        // setValid({ ...valid, cvc: true })
        valid.cvc = true
      }
    }
    setValid({ cc: valid.cc, exp: valid.exp, cvc: valid.cvc })
    if (valid.cc && valid.exp && valid.cvc) props.onSetValid(true)
    else props.onSetValid(false)
    //incompleteMsgRef.current = msg
    setIncompleteMsg({ type: type, msg: msg })
    //console.log('validate msg', msg, type)
  }

  const onFocus = e => {

    //console.log('onFocus', e.target.id, e.target.value)

    setFocused({ ...focused, [e.target.id]: true })
    setChanged({ ...changed, [e.target.id]: false })
    setIncomplete({ ...incomplete, [e.target.id]: false })
  }

  const onChange = e => {
     //console.log('onChange', e.target.id, e.target.value)
    //console.log('incomplete', incompleteMsg)
    if (incompleteMsg.type === e.target.id) {
      setIncompleteMsg({ type: '', msg: '' })
    }

    setChanged({ ...changed, [e.target.id]: true })
    setIncomplete({ ...incomplete, [e.target.id]: false })
    setRequired(false)

    //validateFields()

  }

  const onBlur = e => {
    //console.log('onBlur', e.target.id, e.target.value)

    creditCardRef.current.cc = ccRef.current.value
    creditCardRef.current.exp = expRef.current.value
    creditCardRef.current.cvc = cvcRef.current.value
    props.onBlur(creditCardRef.current)

    setFocused({ ...focused, [e.target.id]: false })

    if (e.target.value === '') {
      if (changed[e.target.id]) {
        if (
          creditCardRef.current.cc === '' &&
          creditCardRef.current.exp === '' &&
          creditCardRef.current.cvc === ''
        )
          setRequired(true)
      }
      setIncomplete({ ...incomplete, [e.target.id]: false })
      setValid({ ...valid, [e.target.id]: false })
      return
    }

    validateFields()
  }

  const style1 = {
    borderTop: 0,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    maxWidth: '201px'
  }
  const style2 = {
    borderTop: 0,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 5,
    maxWidth: '201px'
  }

  function handleCCKeyDown (e) {
    const text = e.target.value
    if (e.key === 'Tab') return
    if (e.keyCode === 8) {
      if (text.length >= 6) {
        // see if there is a space to the left of the space being deleted
        if (text.substring(text.length - 2, text.length - 1) === ' ') {
          e.target.value = text.substring(0, text.length - 2)
          e.preventDefault()
        }
      }
      return
    }

    // return if not a valid key
    if (e.key < '0' || e.key > '9') {
      e.preventDefault()
      return
    }

    // determine if a space should be inserted (e.g. only 4 characters)
    if (ccType === 3) {
      if (text.length === 3 || text.length === 10) {
        e.target.value = text + e.key + ' '
        e.preventDefault()
        return
      }
    } else if (text.length === 3 || text.length === 8 || text.length === 13) {
      e.target.value = text + e.key + ' '
      e.preventDefault()
      return
    }
  }

  function handleCCKeyUp (e) {
    const text = e.target.value

    if (text.substring(0, 1) === '4') setCcType(1)
    else if (text.substring(0, 2) >= '51' && text.substring(0, 2) <= '55') {
      setCcType(2)
    } else if (text.substring(0, 2) >= '22' && text.substring(0, 2) <= '27') {
      setCcType(2)
    } else if (text.substring(0, 2) === '34' || text.substring(0, 2) === '37') {
      setCcType(3)
    } else if (text.substring(0, 2) === '64' || text.substring(0, 2) === '65') {
      setCcType(4)
    } else setCcType(0)

    // see if max digits entered
    if ((ccType === 3 && text.length === 17) || text.length === 19) {

      if( ! validateCardNumber(text.replace(/\s+/g, ''))) {
        setIncomplete({ ...incomplete, creditCard: true })
        setIncompleteMsg({ type: 'creditCard', msg: 'Your card number is invalid.' })
      }
    }
  }

  function handleExpiryDown (e) {
    const text = e.target.value

    if (e.key === 'Tab') return

    if (e.keyCode === 8) {
      // backspace
      if (text.length === 5) {
        // must delete ' / '
        e.target.value = text.substring(0, 2)
        e.preventDefault()
      }
      return
    }

    // / pressed
    if (e.key === '/') {
      if (text === '' || text.indexOf('/') !== -1) {
        // don't allow more than 1
        e.preventDefault()
        return
      }
    }

    // only allow numeric and /
    if ((e.key < '0' || e.key > '9') && e.key !== '/') {
      e.preventDefault()
      return
    }

    // 1st digit pressed
    if (text === '') {
      if (e.key >= '2' && e.key <= '9') {
        e.target.value = '0' + e.key + ' / '
        e.preventDefault()
      }
      return
    }

    // second digit pressed
    if (text.length === 1) {
      if (text.substring(0, 1) === '0') {
        if (e.key !== '0') e.target.value += e.key + ' / '
        e.preventDefault()
        return
      }
      // 1st digit is a 1, only accept 0,1,2
      if (e.key === '/') {
        e.target.value = '0' + e.target.value + ' / '
        e.preventDefault()
        return
      }
      if (e.key >= '0' && e.key <= '2') {
        e.target.value += e.key + ' / '
        e.preventDefault()
        return
      } else if (e.key >= '3' && e.key <= '9') {
        e.target.value = '0' + e.target.value + ' / ' + e.key
        e.preventDefault()
        return
      }
    }

    if (text.length === 2) {
      e.target.value += ' / '
      if (e.key !== '/') e.target.value += e.key
      e.preventDefault()
      return
    }
  }

  function handleExpiryUp (e) {
    const text = e.target.value

    if (text.length === 7) {
      // console.log('check validity')
    }
  }

  function handleCvcChange (e) {
    if (e.keyCode === 8) return
    if (e.key === 'Tab') return

    if (e.key < '0' || e.key > '9') e.preventDefault()
  }

  const CcIcon = () => (
    <Col
      style={{
        position: 'absolute',
        zIndex: '9',
        opacity: '10',
        right: '-55%',
        top: '7px'
      }}
    >
      {(ccType === 0 || ccType === 1) && (
        <Image className='mx-1' src={visaSVG} />
      )}
      {(ccType === 0 || ccType === 2) && (
        <Image className='mx-1' src={mastercardSVG} />
      )}
      {(ccType === 0 || ccType === 3) && (
        <Image className='mx-1' src={amexSVG} />
      )}
      {(ccType === 0 || ccType === 4) && (
        <Image className='mx-1' src={discoverSVG} />
      )}
    </Col>
  )

  const Exclamation = props => (
    <i
      style={{
        color: 'red',
        position: 'absolute',
        padding: '7px',
        right: props.right,
        left: props.left
        // left: '42%'
      }}
      className='float-end bi-exclamation-circle'
    ></i>
  )

  // console.log('CreditCard required', required)

  return (
    <Form.Group className='mb-3'>
      <Title title='Card information' required={required} />
      <InputGroup>
        <Form.Control
          ref={ccRef}
          style={{
            borderColor:
              (required || incomplete.creditCard) &&
              !focused.creditCard &&
              'red'
          }}
          className='border-1 rounded-0 rounded-top '
          placeholder='1234 1234 1234 1234'
          onKeyDown={handleCCKeyDown}
          onKeyUp={handleCCKeyUp}
          maxLength={ccType === 3 ? 17 : 19}
          id='creditCard'
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          disabled={props.disabled}
        />
        {!incomplete.creditCard && <CcIcon />}
        {incomplete.creditCard && <Exclamation right={0} />}
      </InputGroup>
      <InputGroup>
        <Form.Control
          ref={expRef}
          placeholder='MM / YY'
          style={{
            ...style1,
            ...{
              borderColor:
                !focused.expDate && (required || incomplete.expDate) && 'red'
            }
          }}
          maxLength={7}
          onKeyDown={handleExpiryDown}
          onKeyUp={handleExpiryUp}
          id='expDate'
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          disabled={props.disabled}
        />
        {incomplete.expDate && <Exclamation left={'42%'} />}

        <Form.Control
          ref={cvcRef}
          placeholder='CVC'
          style={{
            ...style2,
            ...{
              borderColor: !focused.cvc && (required || incomplete.cvc) && 'red'
            }
          }}
          onKeyDown={handleCvcChange}
          maxLength={ccType === 3 ? 4 : 3}
          id='cvc'
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          disabled={props.disabled}
        />
        {incomplete.cvc && <Exclamation right={0} />}
      </InputGroup>
      {incompleteMsg.msg !== '' && (
        <Form.Text style={{ color: 'red' }}>{incompleteMsg.msg}</Form.Text>
      )}
     
    </Form.Group>
  )
}

export default CreditCard
